import React from "react";
import Link from "next/link";
import { BreadcrumbsMapper } from "@app/utilities/routes";

const convertBreadcrumb = (string) => {
  return string.replace(/[^a-zA-Z0-9,.!@#$%^&*()?]+/g, " ").toLowerCase();
};

type BreadcrumbsProps = {
  className?: string;
  isAmp?: boolean;
  uri: string;
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = (props) => {
  const { isAmp, uri } = props;

  const linkPath = (uri || "")
    .replace(/(\?|#).+$/, "")
    .split("/")
    .filter(Boolean);

  const pathArray = linkPath.map((path, idx) => {
    const result = {
      breadcrumb: path,
      href: "/",
    };

    if (idx === 0) {
      const href = BreadcrumbsMapper[path]?.href || path;
      result.href = href;
    } else {
      result.href = "/" + linkPath.slice(0, idx + 1).join("/");
    }

    return result;
  });

  if (!pathArray) {
    return null;
  }

  return (
    <nav className="breadcrumbs-comp" aria-label="breadcrumbs">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link href="/">
            <a>
              <i className="fa fa-home"></i>
            </a>
          </Link>
        </li>
        {pathArray.map((breadcrumb) => {
          return (
            <li key={breadcrumb.href} className="breadcrumb-item">
              <Link href={breadcrumb.href}>
                <a>{convertBreadcrumb(breadcrumb.breadcrumb)}</a>
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
